<template>
    <div>
        <el-select 
            v-if="mode == 'edit'"
            :ref="reference"
            v-model="tmpValue"
            filterable 
            multiple 
            :placeholder="prop.placeholder" 
            @remove-tag="remove"
            class="wp-10">
                <el-option
                v-for="item in prop.allowedValues"
                :key="item.id"
                :label="item.name"
                :value="parseInt(item.id)">
                </el-option>
        </el-select>
        <p v-else>
            {{concatenatedValues}}
        </p>
    </div>
</template>

<script>
    import CfMixin from '../../../mixins/CustomfieldInputsMixins'
    import MultipleMixin from '../../../mixins/MultipleInputsMixins'

    export default {
        mixins: [CfMixin, MultipleMixin],

        data(){
            return {
            }
        },

        created() {
            if (this.value.length <= 0) {
                if(this.context == 'create'){
                    if(this.prop.allowedValues.length > 0){
                        let defaultValues = this.prop.allowedValues.filter(allowed => allowed.default)
                        if(defaultValues){
                            defaultValues.map(defaultValue => {
                                this.tmpValue.push(parseInt(defaultValue.id))
                            })
                            this.formatAndEmit(this.tmpValue)
                        }
                    }
                }
            }
        },

        computed : {
            selectedItems(){
                return this.prop.allowedValues.filter(value => this.tmpValue.includes(parseInt(value.id)))
            },
            concatenatedValues(){
                return this.selectedItems.map(item => item.name).join(', ')
            }
        },

        methods: {
            checkParams(newValue) {
                let valid = true
                valid = this.checkMinMaxParams(newValue)
                return valid
            }
        },
    }
</script>
